import { getStorageItem } from './utils/domUtil';

var getKruxSegments = function getKruxSegments() {
  var _getStorageItem;

  var value = (_getStorageItem = getStorageItem('kxsegs')) !== null && _getStorageItem !== void 0 ? _getStorageItem : '';
  return value.length > 0 ? value.split(',') : [];
};

var getKruxUID = function getKruxUID() {
  var _getStorageItem2;

  return (_getStorageItem2 = getStorageItem('kxuser')) !== null && _getStorageItem2 !== void 0 ? _getStorageItem2 : '';
};

export { getKruxSegments, getKruxUID };
//# sourceMappingURL=krux.js.map